import BaseView from '../../../core/baseView';
import RemoteEmailValidation from '../../../layout/remoteEmailValidation';
import { reload } from '../../../validation/validation-controller';

export default BaseView.extend({
  initialize: function() {
    reload();

    var $email = this.$('[name="email"]');

    if ($email.length > 0) {
      new RemoteEmailValidation({
        el: $email
      });
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/myAccount/profile/PersonalInformationView.js
 **/